import {
    GoogleMap,
    Marker,
    useJsApiLoader
} from "@react-google-maps/api";

function MapPicker({
    position,
    onPositionChange
}) {

    const { isLoaded } =
        useJsApiLoader({
            googleMapsApiKey:
            process.env.REACT_APP_GOOGLE_MAPS_API_KEY
        });

    if (!isLoaded) {
        return <div>Loading Map...</div>;
    }

    return (

        <GoogleMap
    mapContainerStyle={{
        width: "100%",
        height: "400px"
    }}
    center={{
        lat: position
            ? position[0]
            : 26.0567, // Updated Latitude for Bakalia

        lng: position
            ? position[1]
            : 93.1991  // Updated Longitude for Bakalia
    }}
            zoom={15}
            onClick={(e) => {

                onPositionChange([
                    e.latLng.lat(),
                    e.latLng.lng()
                ]);

            }}
        >

            {
                position && (

                    <Marker
                        position={{
                            lat: position[0],
                            lng: position[1]
                        }}
                        draggable={true}
                        onDragEnd={(e) => {

                            onPositionChange([
                                e.latLng.lat(),
                                e.latLng.lng()
                            ]);

                        }}
                    />

                )
            }

        </GoogleMap>

    );
}

export default MapPicker;